export default function Footer() {
  return (
    <footer className="mt-24 border-t border-surface-border bg-white">
      <div className="container-narrow flex flex-col items-center justify-between gap-4 py-6 text-xs text-ink-400 sm:flex-row">
        <div>© 2026 海千蓦信息咨询有限公司</div>
        <div className="flex items-center gap-3">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-ink-400 hover:text-ink-600"
          >
            沪ICP备2025138775号-3
          </a>
          <span className="text-surface-border">·</span>
          <span>内部使用，禁止外传</span>
        </div>
      </div>
    </footer>
  );
}
